export default __webpack_public_path__ + "static/media/19g30mmwb-1.f777cd9d.jpeg";